import React from "react";
import { useState, useEffect } from 'react';
import { uf_addTimeStr } from '../../modules/utils.mjs'

import '../../index.css';

// il dispositivo embedded (gateway) lavora in UTC e non ha un fs con tzdata (da modificare il defconfig di Buildroots ed implementare un update OTA del rootfs)
function timeToUtcMinutes(time) {
    const [hours, minutes] = time.split(":").map(Number);
    const localDate = new Date();
    localDate.setHours(hours, minutes, 0, 0);
    return localDate.getUTCHours() * 60 + localDate.getUTCMinutes();
}

function utcMinutesToLocalTime(utcMinutes) {
    if (utcMinutes === undefined || utcMinutes === null) {
        return "--:--";
    }
    const date = new Date();
    date.setUTCHours(0, 0, 0, 0);
    date.setUTCMinutes(utcMinutes);
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${hours}:${minutes}`;
}

const ConfigTable = ({
    serial,
    data,
    updateTable,
    mqttReq
}) => {
    const [tableConfigState, setTableConfigState] = useState([]);

    const [tunnelState, setTunnelState] = useState('')
    const [logState, setLogState] = useState(0)
    const [pjLogState, setPJLogState] = useState('')
    const [disableFallMinState, setDisableFallMinState] = useState('')
    const [periodicCheckSState, setPeriodicCheckSState] = useState('')
    const [cyclesWoAAState, setCyclesWoAAState] = useState('')
    const [cyclesWoPBState, setcyclesWoPBState] = useState('')
    const [wsPollingMsState, setWsPollingMsState] = useState('')
    const [enableCallState, setEnableCallState] = useState('')
    const [wkmodeState, setWkmodeState] = useState('')
    const [callRingTimeSState, setCallRingTimeSState] = useState('')
    const [startsForDefaultBrokerState, setStartsForDefaultBrokerState] = useState('')
    const [rebootStartMinuteState, setRebootStartMinuteState] = useState('')
    const [rebootEnableState, setRebootEnableState] = useState('')
    const [updateConfigTableState, setUpdateConfigTableState] = useState('')
    const handleTunnelChange = (event) => { setTunnelState(event.target.value) }
    const handleLogChange = (event) => { setLogState(event.target.value) }
    const handlePJLogCall = (event) => { setPJLogState(event.target.value) }
    const handleDisableFallMinCall = (event) => { setDisableFallMinState(event.target.value) }
    const handlePeriodicCheckSCall = (event) => { setPeriodicCheckSState(event.target.value) }
    const handleCyclesWoAACall = (event) => { setCyclesWoAAState(event.target.value) }
    const handlecyclesWoPBCall = (event) => { setcyclesWoPBState(event.target.value) }
    const handleWsPollingMsCall = (event) => { setWsPollingMsState(event.target.value) }
    const handleEnableCallCall = (event) => { setEnableCallState(event.target.value) }
    const handleWkmodeChange = (event) => { setWkmodeState(event.target.value) }
    const handleCallRingTimeSChange = (event) => { setCallRingTimeSState(event.target.value) }
    const handleStartsForDefaultBrokerChange = (event) => { setStartsForDefaultBrokerState(event.target.value) }
    const handleRebootStartTimeChange = (event) => { setRebootStartMinuteState(timeToUtcMinutes(event.target.value)) }
    const handleRebootEnableChange = (event) => { setRebootEnableState(event.target.value) }

    const [includeTunnel, setIncludeTunnel] = useState(false);
    const [includeLogLevel, setIncludeLogLevel] = useState(false);
    const [includePjLogLevel, setIncludePjLogLevel] = useState(false);
    const [includeDisableFallMin, setIncludeDisableFallMin] = useState(false);
    const [includePeriodicCheckS, setIncludePeriodicCheckS] = useState(false);
    const [includeCyclesWoAA, setIncludeCyclesWoAA] = useState(false);
    const [includeCyclesWoPB, setIncludeCyclesWoPB] = useState(false);
    const [includeWsPolling, setIncludeWsPolling] = useState(false);
    const [includeEnableCall, setIncludeEnableCall] = useState(false);
    const [includeWkMode, setIncludeWkMode] = useState(false);
    const [includeCallRingTimeS, setIncludeCallRingTimeS] = useState(false);
    const [includeStartsForDefaultBroker, setIncludeStartsForDefaultBroker] = useState(false);
    const [includeRebootStartMinute, setIncludeRebootStartMinute] = useState(false);
    const [includeRebootEnable, setIncludeRebootEnable] = useState(false);

    useEffect(() => {
        if ((data !== null) && (data !== undefined))
            uf_addTimeStr(data)
        setTableConfigState(data)
    }, [data]);

    function prepareupdateconfigtable() {
        if (tableConfigState?.tunnel != null) setTunnelState(tableConfigState.tunnel);
        if (tableConfigState?.log_level != null) setLogState(tableConfigState.log_level);
        if (tableConfigState?.pj_log_level != null) setPJLogState(tableConfigState.pj_log_level);
        if (tableConfigState?.disable_fall_min != null) setDisableFallMinState(tableConfigState.disable_fall_min);
        if (tableConfigState?.periodic_check_s != null) setPeriodicCheckSState(tableConfigState.periodic_check_s);
        if (tableConfigState?.cycles_wo_aa != null) setCyclesWoAAState(tableConfigState.cycles_wo_aa);
        if (tableConfigState?.cycles_wo_pb != null) setcyclesWoPBState(tableConfigState.cycles_wo_pb);
        if (tableConfigState?.ws_polling_ms != null) setWsPollingMsState(tableConfigState.ws_polling_ms);
        if (tableConfigState?.enable_call != null) setEnableCallState(tableConfigState.enable_call);
        if (tableConfigState?.wk_mode != null) setWkmodeState(tableConfigState.wk_mode);
        if (tableConfigState?.call_ring_time_s != null) setCallRingTimeSState(tableConfigState.call_ring_time_s);
        if (tableConfigState?.starts_for_default_broker != null) setStartsForDefaultBrokerState(tableConfigState.starts_for_default_broker);
        if (tableConfigState?.reboot_start_minute != null) setRebootStartMinuteState(tableConfigState.reboot_start_minute);
        if (tableConfigState?.reboot_enable != null) setRebootEnableState(tableConfigState.reboot_enable);
    }

    function updateconfigtable() {
        const parsedLogState = parseInt(logState, 10);
        const post_body = {
            serial: serial,
            ...(includeTunnel && { tunnel: tunnelState }),
            ...(includeLogLevel && { log_level: isNaN(parsedLogState) ? 0 : parsedLogState }),
            ...(includePjLogLevel && { pj_log_level: pjLogState }),
            ...(includeDisableFallMin && { disable_fall_min: disableFallMinState }),
            ...(includePeriodicCheckS && { periodic_check_s: periodicCheckSState }),
            ...(includeCyclesWoAA && { cycles_wo_aa: cyclesWoAAState }),
            ...(includeCyclesWoPB && { cycles_wo_pb: cyclesWoPBState }),
            ...(includeWsPolling && { ws_polling_ms: wsPollingMsState }),
            ...(includeEnableCall && { enable_call: enableCallState }),
            ...(includeWkMode && { wk_mode: wkmodeState.toString() }),
            ...(includeCallRingTimeS && { call_ring_time_s: callRingTimeSState.toString() }),
            ...(includeStartsForDefaultBroker && { starts_for_default_broker: startsForDefaultBrokerState.toString() }),
            ...(includeRebootStartMinute && { reboot_start_minute: rebootStartMinuteState.toString() }),
            ...(includeRebootEnable && { reboot_enable: rebootEnableState.toString() }),
        };
        updateTable(post_body, '/configmqttset', setUpdateConfigTableState)
    }

    function refreshconfigtable() {
        mqttReq(serial, '/configmqttreq')
    }

    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className={`GatewayDBTable-Section ${isOpen ? 'open' : ''}`}>
            <button onClick={() => setIsOpen(!isOpen)} style={{ marginBottom: '10px' }}>
                {isOpen ? 'Nascondi Config' : 'Mostra Config'}
            </button>
            {isOpen && (
                <table className="GatewayDBTable">
                     <colgroup>
                        <col style={{ width: "15%" }} />
                        <col style={{ width: "40%" }} />
                        <col style={{ width: "40%" }} />
                        <col style={{ width: "5%" }} />
                    </colgroup>
                    <tbody>
                        {/* Title */}
                        <tr>
                            <th className="tabletitle" colSpan="4">CONFIG</th>
                        </tr>

                        {/* Header */}
                        <tr>
                            <th className="title">Campo</th>
                            <th className="title">Valore attuale</th>
                            <th className="title">Nuovo valore</th>
                            <th className="title">✔</th>
                        </tr>

                        {/* Tunnel */}
                        <tr>
                            <td>Server (tunnel)
                              <span
                                className="help-icon"
                                title="URL del server usato per i tunnel ssh."
                              >
                                ⓘ
                              </span>
                            </td>
                            <td style={{ textAlign: 'center' }}>{tableConfigState?.tunnel}</td>
                            <td>
                                <input type="text" value={tunnelState} onChange={handleTunnelChange} />
                            </td>
                            <td><input type="checkbox" checked={includeTunnel} onChange={() => setIncludeTunnel(!includeTunnel)} /></td>
                        </tr>

                        {/* Log */}
                        <tr>
                            <td>Log
                              <span
                                className="help-icon"
                                title="Bitwise inoltro del log del gateway su MQTT: 1 API, 2 MQTT, 4 SIP, 8 WK, 16 PERIODIC, 32 WEBSOCKET"
                              >
                                ⓘ
                              </span>
                            </td>
                            <td style={{ textAlign: 'center' }}>{tableConfigState?.log_level}</td>
                            <td>
                                <input type="text" value={logState} onChange={handleLogChange} />
                            </td>
                            <td><input type="checkbox" checked={includeLogLevel} onChange={() => setIncludeLogLevel(!includeLogLevel)} /></td>
                        </tr>

                        {/* PJ Log */}
                        <tr>
                            <td>PJ log
                              <span
                                className="help-icon"
                                title="Dettaglio del Log della libreria PJ."
                              >
                                ⓘ
                              </span>
                            </td>
                            <td style={{ textAlign: 'center' }}>{tableConfigState?.pj_log_level}</td>
                            <td>
                                <input type="text" value={pjLogState} onChange={handlePJLogCall} />
                            </td>
                            <td><input type="checkbox" checked={includePjLogLevel} onChange={() => setIncludePjLogLevel(!includePjLogLevel)} /></td>
                        </tr>

                        {/* Fall Disable Min */}
                        <tr>
                            <td>Fall Disable min.
                              <span
                                className="help-icon"
                                title="Minuti di blocco temporaneo di avviso/chiamata cadute. In alcune strutture è usato per bloccare le allerte in Dipas."
                              >
                                ⓘ
                              </span>
                            </td>
                            <td style={{ textAlign: 'center' }}>{tableConfigState?.disable_fall_min}</td>
                            <td>
                                <input type="text" value={disableFallMinState} onChange={handleDisableFallMinCall} />
                            </td>
                            <td><input type="checkbox" checked={includeDisableFallMin} onChange={() => setIncludeDisableFallMin(!includeDisableFallMin)} /></td>
                        </tr>

                        {/* Period sec. */}
                        <tr>
                            <td>Period sec.
                              <span
                                className="help-icon"
                                title="Durata in secondi del ciclo di controllo periodico dello stato dei sensori (online/offline)."
                              >
                                ⓘ
                              </span>
                            </td>
                            <td style={{ textAlign: 'center' }}>{tableConfigState?.periodic_check_s}</td>
                            <td>
                                <input type="text" value={periodicCheckSState} onChange={handlePeriodicCheckSCall} />
                            </td>
                            <td><input type="checkbox" checked={includePeriodicCheckS} onChange={() => setIncludePeriodicCheckS(!includePeriodicCheckS)} /></td>
                        </tr>

                        {/* Cicli no AA */}
                        <tr>
                            <td>Cicli no AA
                              <span
                                className="help-icon"
                                title="Cicli senza AA online prima di mandare un messaggio MQTT per notificare lo stato."
                              >
                                ⓘ
                              </span>
                            </td>
                            <td style={{ textAlign: 'center' }}>{tableConfigState?.cycles_wo_aa}</td>
                            <td>
                                <input type="text" value={cyclesWoAAState} onChange={handleCyclesWoAACall} />
                            </td>
                            <td><input type="checkbox" checked={includeCyclesWoAA} onChange={() => setIncludeCyclesWoAA(!includeCyclesWoAA)} /></td>
                        </tr>

                        {/* Cicli no PB */}
                        <tr>
                            <td>Cicli no PB
                            <span
                                className="help-icon"
                                title="Cicli senza PB online prima di mandare un messaggio MQTT per notificare lo stato."
                              >
                                ⓘ
                              </span>
                            </td>
                            <td style={{ textAlign: 'center' }}>{tableConfigState?.cycles_wo_pb}</td>
                            <td>
                                <input type="text" value={cyclesWoPBState} onChange={handlecyclesWoPBCall} />
                            </td>
                            <td><input type="checkbox" checked={includeCyclesWoPB} onChange={() => setIncludeCyclesWoPB(!includeCyclesWoPB)} /></td>
                        </tr>

                        {/* WS polling */}
                        <tr>
                            <td>WS polling
                              <span
                                className="help-icon"
                                title="Periodo in ms del polling della websocket interna per ricevere eventi dai dispositivi collegati con Zigbee."
                              >
                                ⓘ
                              </span>
                            </td>
                            <td style={{ textAlign: 'center' }}>{tableConfigState?.ws_polling_ms}</td>
                            <td>
                                <input type="text" value={wsPollingMsState} onChange={handleWsPollingMsCall} />
                            </td>
                            <td><input type="checkbox" checked={includeWsPolling} onChange={() => setIncludeWsPolling(!includeWsPolling)} /></td>
                        </tr>

                        {/* Enable call */}
                        <tr>
                            <td>Enable Call
                              <span
                                className="help-icon"
                                title="Abilita le chiamate VoIP in caso di caduta, PB e pulsante AA."
                              >
                                ⓘ
                              </span>
                            </td>
                            <td style={{ textAlign: 'center' }}>{tableConfigState?.enable_call}</td>
                            <td>
                                <input type="text" value={enableCallState} onChange={handleEnableCallCall} />
                            </td>
                            <td><input type="checkbox" checked={includeEnableCall} onChange={() => setIncludeEnableCall(!includeEnableCall)} /></td>
                        </tr>

                        {/* WK (mode) DB Version 1 */}
                        <tr>
                            <td>WK (mode)
                              <span
                                className="help-icon"
                                title="0 - nessun ticket alla CB/WK, 1 - ticket inviati all'API della CB/WK, 2 - solo ticket di test alla CB/WK"
                              >
                                ⓘ
                              </span>
                            </td>
                            <td style={{ textAlign: 'center' }}>{tableConfigState?.wk_mode}</td>
                            <td>
                                <input  type="text" value={wkmodeState} onChange={handleWkmodeChange}/>
                            </td>
                            <td>
                                <input type="checkbox" checked={includeWkMode} onChange={() => setIncludeWkMode(!includeWkMode)} />
                            </td>
                        </tr>

                        {/* Call Ring Time sec. DB Version 1 */}
                        <tr>
                            <td>Ring time sec.
                              <span
                                className="help-icon"
                                title="Durata in secondi della fase di squilli prima di passare al successivo destinatario."
                              >
                                ⓘ
                              </span>
                            </td>
                            <td style={{ textAlign: 'center' }}>{tableConfigState?.call_ring_time_s}</td>
                            <td>
                                <input  type="text" value={callRingTimeSState} onChange={handleCallRingTimeSChange}/>
                            </td>
                            <td>
                                <input type="checkbox" checked={includeCallRingTimeS} onChange={() => setIncludeCallRingTimeS(!includeCallRingTimeS)} />
                            </td>
                        </tr>

                        {/* Starts for Broker default DB Version 1 */}
                        <tr>
                            <td># starts for Default Broker
                              <span
                                className="help-icon"
                                title="Numero di riavvi da raggiungere (# start) prima di passare al broker di test 
                                in caso di mancata connessione al broker principale. Se la riconnessione funziona sempre 
                                #start può anche continuare ed aumentare ad oltranza."
                              >
                                ⓘ
                              </span>
                            </td>
                            <td style={{ textAlign: 'center' }}>{tableConfigState?.starts_for_default_broker}</td>
                            <td>
                                <input  type="text" value={startsForDefaultBrokerState} onChange={handleStartsForDefaultBrokerChange}/>
                            </td>
                            <td>
                                <input type="checkbox" checked={includeStartsForDefaultBroker} onChange={() => setIncludeStartsForDefaultBroker(!includeStartsForDefaultBroker)} />
                            </td>
                        </tr>

                        {/* Reboot time */}
                        <tr>
                            <td>Reboot Time
                              <span
                                className="help-icon"
                                title="Orario del reboot giornaliero (+30 min di finestra, non fa reboot se c'è una chiamata in corso ma riprova dopo)."
                              >
                                ⓘ
                              </span>
                            </td>
                            <td style={{ textAlign: 'center' }}>{utcMinutesToLocalTime(tableConfigState?.reboot_start_minute)}</td>
                            <td>
                                <input type="time" value={utcMinutesToLocalTime(rebootStartMinuteState)} onChange={handleRebootStartTimeChange}/>
                            </td>
                            <td>
                                <input type="checkbox" checked={includeRebootStartMinute} onChange={() => setIncludeRebootStartMinute(!includeRebootStartMinute)} />
                            </td>
                        </tr>

                        {/* Reboot enable */}
                        <tr>
                            <td>Enable Reboot
                              <span
                                className="help-icon"
                                title="Abilita il reboot giornaliero del gateway."
                              >
                                ⓘ
                              </span>
                            </td>
                            <td style={{ textAlign: 'center' }}>{tableConfigState?.reboot_enable}</td>
                            <td>
                                <input  type="text" value={rebootEnableState} onChange={handleRebootEnableChange}/>
                            </td>
                            <td>
                                <input type="checkbox" checked={includeRebootEnable} onChange={() => setIncludeRebootEnable(!includeRebootEnable)} />
                            </td>
                        </tr>

                        {/* Ultimo aggiornamento */}
                        <tr>
                            <td className="timetitle">Ultimo aggiornamento</td>
                            <td style={{ textAlign: 'center' }}>{tableConfigState?.time}</td>
                            <td style={{ textAlign: 'center' }}>{updateConfigTableState}</td>
                            <td></td>
                        </tr>

                        {/* Buttons row */}
                        <tr>
                            <td colSpan="4" style={{ textAlign: 'center' }}>
                                <button onClick={refreshconfigtable} style={{ marginRight: '20px' }}>aggiorna</button>
                                <button onClick={prepareupdateconfigtable} style={{ marginRight: '20px' }}>&gt;</button>
                                <button onClick={updateconfigtable}>invia</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default ConfigTable;
